import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,TableContainer,
      Paper,
    TableBody, Checkbox,
    TableCell, FormControlLabel,
    CircularProgress,
} from "@material-ui/core";
import { saveAs } from 'file-saver';
import { Card, Box, Typography } from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import ActivityService from "./Locality/Service/activityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import SubActivityService from "./Locality/Service/subActivityService";
import StudentService from "./Locality/Service/studentService"
import SuperActivityService from "./Locality/Service/superActivityService"
import * as Yup from 'yup';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import LanguageIcon from '@material-ui/icons/Language';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import HistoryIcon from '@material-ui/icons/History';
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import ExportExcel from "../../Excelexport";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    infoNote: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        borderRadius: 8,
        backgroundColor: theme.palette.type === 'light' ? 'rgba(25, 118, 210, 0.08)' : 'rgba(25, 118, 210, 0.16)',
        border: `1px solid ${theme.palette.type === 'light' ? 'rgba(25, 118, 210, 0.24)' : 'rgba(25, 118, 210, 0.4)'}`,
    },
    infoNoteIcon: {
        color: theme.palette.info.main,
        marginTop: 2,
        flexShrink: 0,
    },
    infoNoteText: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        lineHeight: 1.5,
    },
    infoNoteLabel: {
        fontWeight: 600,
        color: theme.palette.info.dark || theme.palette.primary.main,
        marginBottom: 2,
    },
}));
export default function StudentActivity() {
    const tableHeaders = ['Class', 'Section', 'Area Of Work', 'List Of Activities', 'Exercises', 'Remarks',
        'Key', 'Start Date', 'End Date', 'Edit', 'Delete', 'Add More', 'History', 'Public Status'];
    const classes = useStyles();
    const [openHistory, setOpenHistory] = useState(false);
    const [selectedHistory, setSelectedHistory] = useState([]);
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [checkedActivities, setCheckedActivities] = useState([]);
    const [selectedActivityMap, setSelectedActivityMap] = useState({});  // Store relationships between sub-activities and their parents
    const [checkedSubActivities, setCheckedSubActivities] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [openMessageDialog, setOpenMessageDialog] = useState(false);
    const [messageDialogContent, setMessageDialogContent] = useState({ title: '', message: '', type: 'info' });
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [activityToDelete, setActivityToDelete] = useState(null);
    const [openUnmasteredDialog, setOpenUnmasteredDialog] = useState(false);
    const [unmasteredActivitiesList, setUnmasteredActivitiesList] = useState([]);
    const [pendingFormValues, setPendingFormValues] = useState(null);
    const [pendingResetForm, setPendingResetForm] = useState(null);
    const [groupedUnmasteredActivities, setGroupedUnmasteredActivities] = useState({}); // Grouped by studentId._id
    const [filteredUnmasteredActivities, setFilteredUnmasteredActivities] = useState([]); // Activities for selected students

    const [activityList, setActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [subActivityList, setSubActivityList] = useState([]);
    const [studentReportList, setStudentReportList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [activityIdList, setActivityIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isAdd, setIsAdd] = React.useState(false);
    const [subActivityIdList, setSubActivityIdList] = useState([]);
    const [addActivityList, setAddActivityList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [result, setResult] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [sectionId, setSectionId] = useState('');
    const [dialogSectionList, setDialogSectionList] = useState([]);
    const [studentReportResult, setStudentReportResult] = useState([]);
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const today = new Date();
    const [keyList, setKeyList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [addActivityLoading, setAddActivityLoading] = useState(false);

    const keyOptions = [
        { label: 'Presented(1)', value: 'P' },
        { label: 'Works with Assistance(2)', value: 'WA' },
        { label: 'Works Independently(3)', value: 'WI' },
        { label: 'Mastered(4)', value: 'M' }
    ];

    // Function to get color styling for key status
    const getKeyStatusStyle = (key) => {
        switch (key) {
            case 'P': // Presented
                return {
                    backgroundColor: '#2196F3', // Blue
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'WA': // Work with Assistance
                return {
                    backgroundColor: '#FF9800', // Orange
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'WI': // Work Independently
                return {
                    backgroundColor: '#9C27B0', // Purple
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'M': // Mastered
                return {
                    backgroundColor: '#4CAF50', // Green
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            default:
                return {};
        }
    };

    // Function to get key status text
    const getKeyStatusText = (key) => {
        switch (key) {
            case 'P':
                return 'Presented';
            case 'WA':
                return 'Work with Assistance';
            case 'WI':
                return 'Work Independently';
            case 'M':
                return 'Mastered';
            default:
                return key;
        }
    };

    // Function to format date to D/M/Y format
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                // If dateString is already in YYYY-MM-DD format, parse it manually
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    const day = parts[2];
                    const month = parts[1];
                    const year = parts[0];
                    return `${day}/${month}/${year}`;
                }
                return dateString;
            }
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (error) {
            return dateString;
        }
    };

    // Function to check if activity should be highlighted (end date passed and not mastered)
    const shouldHighlightRow = (activity) => {
        if (!activity.endDate) return false;
        if (activity.key === 'M') return false; // Don't highlight if mastered
        
        try {
            const endDate = new Date(activity.endDate);
            const today = new Date();
            // Set time to midnight for accurate date comparison
            today.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);
            
            // Check if end date has passed
            return endDate < today;
        } catch (error) {
            return false;
        }
    };
    const getWeekStartEnd = (date) => {
        const startOfWeek = new Date(date);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
        const endOfWeek = new Date(date);
        endOfWeek.setDate(endOfWeek.getDate() + (5 - endOfWeek.getDay()));

        let startDay = startOfWeek.getDate();
        let startMonth = startOfWeek.getMonth() + 1;
        let startYear = startOfWeek.getFullYear();
        if (startDay < 10) {
            startDay = '0' + startDay;
        }

        if (startMonth < 10) {
            startMonth = `0${startMonth}`;
        }
        let format = startYear + "-" + startMonth + "-" + startDay;

        let endDay = endOfWeek.getDate();
        let endMonth = endOfWeek.getMonth() + 1;
        let endYear = endOfWeek.getFullYear();
        if (endDay < 10) {
            endDay = '0' + endDay;
        }

        if (endMonth < 10) {
            endMonth = `0${endMonth}`;
        }

        let format1 = endYear + "-" + endMonth + "-" + endDay;

        return { start: format, end: format1 };
    }
    const date = new Date();
    const week = getWeekStartEnd(date);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const year = today.getFullYear();

    const [activity, setActivity] = useState({
        classId: '',
        sectionId: '',
        // date: new Date().toISOString().split("T")[0],
        // studentId: '',
        studentId: [],
        superActivityId: '',
        activityId: '',
        subActivityId: '',
        key: '',
        remarks: '',
        // planning: '',
        isEdit: false,
        endDate: '',
        date: '',
    });

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const verifyeetnt = () => {
        console.log(formik)
    }
    const formRefs = {
        date: React.useRef(),
        endDate: React.useRef(),
        classId: React.useRef(),
        studentId: React.useRef(),
        remarks: React.useRef()
    };
    const filterTreeNode = (node) => {
        if (searchTerm === "") return true;
        const term = searchTerm.toLowerCase();

        // Check if current node matches
        if (node.superActivityName?.toLowerCase().includes(term) ||
            node.activityName?.toLowerCase().includes(term) ||
            node.subActivityName?.toLowerCase().includes(term)) {
            return true;
        }

        // Check children (activities)
        if (node.activities?.some(activity =>
            activity.activityName?.toLowerCase().includes(term) ||
            activity.subActivities?.some(sub =>
                sub.subActivityName?.toLowerCase().includes(term)
            )
        )) {
            return true;
        }

        // Check sub-activities
        if (node.subActivities?.some(sub =>
            sub.subActivityName?.toLowerCase().includes(term)
        )) {
            return true;
        }

        return false;
    };
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const getAllSuperActivityTabelMultiple = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityTabelMultiple(getsupActList).then((res) => {

            setSelectedActivities(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    //   };

    //   const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    //   };
    // classId: Yup.string().required('Class Name is required'),

    const validationSchema = Yup.object().shape({
        classId: Yup.string().required('Class Name is required'),
       // date: Yup.string(new Date().toISOString().split("T")[0]).required('Date is required'),
        studentId: Yup.array(),
        activityId: Yup.string(),
        subActivityId: Yup.string().nullable(),
        key: Yup.string(),
        // academicYear:Yup.string(),
        remarks: Yup.string(),
        planning: Yup.string(),
        //date: Yup.string().nullable(),
        isEdit: Yup.boolean(),
        date: Yup.string().required('date is required'),
        endDate: Yup.string().required('date is required'),
        isEventForAllStudent: Yup.boolean(),
    });
    useEffect(() => {
        // Set initial dates to current week's start and end
        setStartDate1(week.start);
        setEndDate1(week.end);
        
        //getActivityList();
        onSubmit(week.start, week.end);
        // getStudentActivityList();

        getAddClassList();
        //  getSuperActivityList();
        return () => {
            setSubActivityList([]);
            setActivityIdList([]);
            setActivityList([]);
            setAddClassList([]);
            setStudentList([]);
            setAddSuperActivityList([]);
            setStudentReportList([]);
        }
    }, []);
    // useEffect(() => {
    //     //getActivityList();
    //     onSubmit();
    //     // getStudentActivityList();

    //     getAddClassList();
    //     //  getSuperActivityList();
    //     return () => {
    //         setSubActivityList([]);
    //         setActivityIdList([]);
    //         setActivityList([]);
    //         setStudentList([]);
    //         setAddSuperActivityList([]);
    //         setStudentReportList([]);
    //     }
    // }, []);
    
    // Function to check for duplicate activities
    // const checkDuplicateActivities = async (studentIds, activityRelationships, isEventForAllStudent, classId) => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     const duplicates = [];
        
    //     // Get all students to check (handle "For All Class Students" case)
    //     let studentsToCheck = studentIds;
    //     if (isEventForAllStudent && classId) {
    //         // If "For All Class Students" is checked, fetch all students in the class
    //         try {
    //             const allStudents = await StudentService.getAllStudentById(userDetails.schooleId, { classId });
    //             studentsToCheck = allStudents.map(student => student._id);
    //         } catch (error) {
    //             console.error('Error fetching all students:', error);
    //             // Fallback to selected students if fetch fails
    //             studentsToCheck = studentIds;
    //         }
    //     }

    //     // Check each student and activity combination
    //     for (const studentId of studentsToCheck) {
    //         for (const [key, relationship] of Object.entries(activityRelationships)) {
    //             const checkData = {
    //                 schooleId: userDetails.schooleId,
    //                 classId: classId,
    //                 studentId: studentId,
    //                 isFuturePlanning: false
    //             };

    //             try {
    //                 const existingActivities = await ActivityService.findActivityList(checkData);
                    
    //                 // Check if any activity record matches
    //                 if (existingActivities && existingActivities.length > 0) {
    //                     for (const activityGroup of existingActivities) {
    //                         if (activityGroup.activityRecordsId && activityGroup.activityRecordsId.length > 0) {
    //                             const matchingRecord = activityGroup.activityRecordsId.find(record => {
    //                                 const activityMatch = record.activityId?._id === relationship.activityId;
    //                                 const subActivityMatch = relationship.subActivityId 
    //                                     ? record.subActivityId?._id === relationship.subActivityId
    //                                     : !record.subActivityId; // If no subActivity in relationship, check for null in record
    //                                 return activityMatch && subActivityMatch;
    //                             });
                                
    //                             if (matchingRecord) {
    //                                 const studentName = activityGroup.studentId 
    //                                     ? `${activityGroup.studentId.firstName} ${activityGroup.studentId.lastName}`
    //                                     : 'Unknown Student';
    //                                 const activityName = matchingRecord.activityId?.activityName || 'Unknown Activity';
    //                                 const subActivityName = matchingRecord.subActivityId?.subActivityName || '';
    //                                 duplicates.push({
    //                                     studentId,
    //                                     studentName,
    //                                     activityName,
    //                                     subActivityName: subActivityName || 'N/A'
    //                                 });
    //                             }
    //                         }
    //                     }
    //                 }
    //             } catch (error) {
    //                 console.error('Error checking duplicates:', error);
    //             }
    //         }
    //     }
        
    //     return duplicates;
    // };

    // Function to fetch and group unmastered activities by studentId
    const fetchAndGroupUnmasteredActivities = async (classId, schooleId) => {
        try {
            if (!classId || !schooleId) {
                setGroupedUnmasteredActivities({});
                return;
            }

            // Get all students in the class
        

            const checkData = {
                schooleId: schooleId,
                classId: classId,
                sectionId: sectionId || undefined,
            };

            const response = await ActivityService.getUnmasteredActivities(checkData);
            const responseData = response.data || response;
            
            if (responseData && responseData.success && responseData.activities) {
                // Group activities by studentId._id
                const grouped = {};
                responseData.activities.forEach(activity => {
                    const studentIdKey = activity.studentId?._id;
                    if (studentIdKey) {
                        if (!grouped[studentIdKey]) {
                            grouped[studentIdKey] = [];
                        }
                        grouped[studentIdKey].push(activity);
                    }
                });
                setGroupedUnmasteredActivities(grouped);
            } else {
                setGroupedUnmasteredActivities({});
            }
        } catch (error) {
            console.error('Error fetching unmastered activities:', error);
            setGroupedUnmasteredActivities({});
        }
    };

    // Function to check unmastered activities before submitting
    const checkUnmasteredActivitiesBeforeSubmit = async (studentIds, classId, isEventForAllStudent, schooleId) => {
        try {
            let studentsToCheck = studentIds || [];
            debugger
            // If "For All Class Students" is selected, fetch all students in the class
            if (isEventForAllStudent && classId) {
                try {
                    const allStudents = await StudentService.getAllStudentById(schooleId, { classId });
                    studentsToCheck = allStudents.map(student => student._id);
                } catch (error) {
                    console.error('Error fetching all students:', error);
                    studentsToCheck = studentIds || [];
                }
            }

            if (!studentsToCheck || studentsToCheck.length === 0) {
                return { hasUnmastered: false, activities: [], count: 0 };
            }

            const checkData = {
                studentId: studentsToCheck,
                schooleId: schooleId,
                classId: classId,
                sectionId: sectionId || undefined,
            };

            const response = await ActivityService.getUnmasteredActivities(checkData);
            const responseData = response.data || response;
            
            if (responseData && responseData.success && responseData.count > 0) {
                return {
                    hasUnmastered: true,
                    activities: responseData.activities || [],
                    count: responseData.count || 0
                };
            }

            return {
                hasUnmastered: false,
                activities: [],
                count: 0
            };
        } catch (error) {
            console.error('Error checking unmastered activities:', error);
            return { hasUnmastered: false, activities: [], count: 0 };
        }
    };

    // Function to submit activity after user confirms
    const submitActivityAfterConfirmation = (values, resetForm) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        let currentYear = new Date().getFullYear();
        let nextYear = new Date().getFullYear() + 1;
        values['academicYear'] = currentYear + "-" + nextYear;
        values.subActivityId = (values.subActivityId && values.subActivityId.trim() !== '') ? values.subActivityId : null;
        values.date = values.date ? values.date : new Date().toISOString().split("T")[0];
        values.isEventForAllStudent = values.isEventForAllStudent || false;
        values.schooleId = userDetails.schooleId;
        values.sectionId = values.sectionId || sectionId || null;
        values.authorizedPerson = userDetails.email;
        values.isFuturePlanning = false;
        values.studentId = values.studentId;
        values.activityRelationships = selectedActivityMap;
        
        setAddActivityLoading(true);
        ActivityService.creteMultipleActivity(values).then((res) => {
            setAddActivityLoading(false);
            onSubmit();
            resetForm();
            setCheckedActivities([]);
            setSelectedActivityMap({});
            setCheckedSubActivities([]);
            handleClose();
            setMessageDialogContent({
                title: 'Success',
                message: 'Activity Added Successfully.',
                type: 'success'
            });
            setOpenMessageDialog(true);
        }).catch((err) => {
            setAddActivityLoading(false);
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to add activity.',
                type: 'error'
            });
            setOpenMessageDialog(true);
        });
    };

    const formik = useFormik({
        initialValues: activity,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.authorizedPerson = userDetails.email
            values.isFuturePlanning = false
            values.studentId = values.studentId
            values.sectionId = values.sectionId || sectionId || null;
            values.activityRelationships = selectedActivityMap;

            if (activity._id) {
                ActivityService.upadeActivity(values).then((res) => {
                    handleClose();
                    // getActivityList();
                    onSubmit()
                    resetForm()
                    setMessageDialogContent({
                        title: 'Success',
                        message: 'Activity Updated Successfully.',
                        type: 'success'
                    });
                    setOpenMessageDialog(true);
                }).catch((err) => {
                    setMessageDialogContent({
                        title: 'Error',
                        message: err.response?.data?.message || 'Failed to update activity.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                });
            }
            else {
                // Validation checks
                if (!values.isEventForAllStudent && (!values.studentId || values.studentId.length === 0)) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one student.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                if (!selectedActivityMap || Object.keys(selectedActivityMap).length === 0) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one activity.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                // Proceed directly with submission
                submitActivityAfterConfirmation(values, resetForm);
            }

        },
    });
    const renderTree = (node) => {
        // Don't render if it doesn't match the search
        if (!filterTreeNode(node)) return null;
        const superActivitId = node._id;
        // Super Activity node
        if (node.superActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    // label={node.superActivityName}
                    label={
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <LanguageIcon style={{ marginRight: 8, color: "#4caf50" }} />
                            {node.superActivityName}
                        </div>
                    }
                    onClick={(e) => e.stopPropagation()}
                >
                    {Array.isArray(node.activities) && node.activities.map(renderTree)}
                </TreeItem>
            );
        }
        // Activity node
        if (node.activityName) {
            const hasSubActivities = Array.isArray(node.subActivities) && node.subActivities.length > 0;
            const subActivityIds = hasSubActivities ? node.subActivities.map(sub => sub._id) : [];

            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        setCheckedActivities(prev => [...prev, node._id]);
                                        // If there are no subActivities, treat the activity itself as a selectable item
                                        if (!hasSubActivities) {
                                            setSelectedActivityMap(prev => ({
                                                ...prev,
                                                [node._id]: {
                                                    activityId: node._id,
                                                    superActivityId: node.superActivityId,
                                                    isChild: false
                                                    // No subActivityId since this is the activity itself
                                                }
                                            }));
                                        }
                                    } else {
                                        setCheckedActivities(prev => prev.filter(id => id !== node._id));
                                        if (!hasSubActivities) {
                                            setSelectedActivityMap(prev => {
                                                const newMap = { ...prev };
                                                delete newMap[node._id];
                                                return newMap;
                                            });
                                        }
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.activityName}</span>
                        </div>
                    }
                >
                    {hasSubActivities && node.subActivities.map(sub =>
                        renderTree({ ...sub, parentActivityId: node._id, superActivityId: node.superActivityId, isChild: true })
                    )}
                </TreeItem>
            );
        }
        // SubActivity node
        if (node.subActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedSubActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        // Check sub-activity
                                        setCheckedSubActivities(prev => [...prev, node._id]);
                                        // Check parent activity if not already checked
                                        if (!checkedActivities.includes(node.parentActivityId)) {
                                            setCheckedActivities(prev => [...prev, node.parentActivityId]);
                                        }
                                        // Store the relationship
                                        setSelectedActivityMap(prev => ({
                                            ...prev,
                                            [node._id]: {
                                                subActivityId: node._id,
                                                activityId: node.parentActivityId,
                                                superActivityId: node.superActivityId,
                                                isChild: true
                                            }
                                        }));
                                    } else {
                                        // Just uncheck the sub-activity
                                        setCheckedSubActivities(prev => prev.filter(id => id !== node._id));
                                        // Remove the relationship
                                        setSelectedActivityMap(prev => {
                                            const newMap = { ...prev };
                                            delete newMap[node._id];
                                            return newMap;
                                        });
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.subActivityName}</span>
                        </div>
                    }
                />
            );
        }
        return null;
    };
    const groupByStudentId = (data) => {
        return data.reduce((acc, item) => {
            const studentId = item.studentId ? item.studentId._id : "";

            if (!acc[studentId]) {
                acc[studentId] = {
                    studentDetails: {
                        _id: studentId,
                        firstName: item.studentId.firstName,
                        lastName: item.studentId.lastName,
                    },
                    activities: [],
                };
            }
            acc[studentId].activities.push(item);
            return acc;
        }, {});
    };
    const getSuperActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityById(userDetails.schooleId, getsupActList).then((res) => {

            setAddSuperActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const loadDialogSectionList = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setDialogSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === 'TEACHER' && userDetails.sectionId) {
                //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
                // }
                setDialogSectionList(list);
            })
            .catch(() => setDialogSectionList([]));
    };

    const handleOpen = (isAdd) => {
        setOpen(true);
        if (isAdd) {
            const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
            const initialSectionId = (userDetails.role === 'TEACHER' && userDetails.sectionId)
                ? userDetails.sectionId
                : (sectionId || '');
            setActivity({
                classId: classId || '',
                sectionId: initialSectionId,
                // date: new Date().toISOString().split("T")[0],
                // studentId: '',
                studentId: [],
                superActivityId: '',
                activityId: '',
                subActivityId: '',
                key: '',
                remarks: '',
                // planning: '',
                isEdit: false,
                endDate: '',
                sfd: '',
            });
            loadDialogSectionList(classId || '');
            if (classId) {
                // Load activity tree for the class so activities show when section/student are selected (without waiting for student)
                getAllSuperActivityTabelMultiple({ target: { value: classId } });
                getStudentList({ target: { value: classId } }, null, sectionId || undefined);
            } else {
                setStudentList([]);
            }
            // Clear activity selection state
            setCheckedActivities([]);
            setSelectedActivityMap({});
            setCheckedSubActivities([]);
            // Clear unmastered activities
            setGroupedUnmasteredActivities({});
            setFilteredUnmasteredActivities([]);
        }
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
        // Clear activity selection state when closing the dialog
        setCheckedActivities([]);
        setSelectedActivityMap({});
        setCheckedSubActivities([]);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const getSectionListByClass = (classId, defaultSectionId, onLoaded) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            setSectionId('');
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === 'TEACHER' && userDetails.sectionId) {
                //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
                // }
                setSectionList(list);
                if (defaultSectionId) {
                    setSectionId(defaultSectionId);
                }
                if (typeof onLoaded === 'function') {
                    onLoaded();
                }
            })
            .catch(() => {
                setSectionList([]);
                if (typeof onLoaded === 'function') {
                    onLoaded();
                }
            });
    };

    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!userDetails.schooleId) return;
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            const list = Array.isArray(res) ? res : [];
            // For TEACHER: only show their assigned class so class name and section show by default
            const filteredList = userDetails.role === "TEACHER" && userDetails.classId
                ? list.filter((c) => String(c._id) === String(userDetails.classId))
                : list;
            setAddClassList(filteredList);

            // By default show teacher's class name and section when they have classId (and optionally sectionId)
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                const defaultSectionId = userDetails.sectionId ? String(userDetails.sectionId) : '';
                if (defaultSectionId) {
                    setSectionId(defaultSectionId);
                }
                const classIdForStudents = userDetails.classId;
                getSectionListByClass(userDetails.classId, defaultSectionId || undefined, () => {
                    // After section list (and default section) are set, load students so section filter applies on first load
                    getStudentList({ target: { value: classIdForStudents } }, null, defaultSectionId || undefined);
                });
            } else {
                setClassId("");
                setSectionId("");
                setSectionList([]);
            }
        }).catch((err) => {
            setAddClassList([]);
        });
    };
    const excelExport = (res) => {
        const result = [];
        res.forEach((group) => {
            const studentName = group.studentId
                ? `${group.studentId.firstName} ${group.studentId.lastName}`
                : '';
            const className = group.classId?.className || '';

            group.activityRecordsId.forEach((activity) => {
                result.push({
                    "Student Name": studentName,
                    "Class Name": className,
                    "Area Of Work": activity.superActivityId?.superActivityName || '',
                    "List Of Activities": activity.activityId?.activityName || '',
                    "Exercise": activity.subActivityId?.subActivityName || '',
                    "Remarks": activity.remarks || '',
                    "Key": activity.key,
                    "Date": activity.date || '',
                });
            });
        });
        console.log(result)
        setResult(result);
    };
    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate1 = startDate1 ? startDate1 : "";
        const newendDate1 = endDate1 ? endDate1 : "";
        if (studentId == '') {
            setMessageDialogContent({
                title: 'Validation Error',
                message: 'Please Select Student',
                type: 'error'
            });
            setOpenMessageDialog(true);
            return;
        }
        const getstudentId = { "studentId": studentId, "startDate1": newstartDate1, "endDate1": newendDate1 };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'An error occurred',
                type: 'error'
            });
            setOpenMessageDialog(true);
        });
    }
    const onSubmit = (startDate, endDate) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate = startDate1 ? startDate1 : startDate;
        const newendDate = endDate1 ? endDate1 : endDate;
        
        const keys = { 
            "schooleId": userDetails.schooleId, 
            "isFuturePlanning": false, 
            "studentId": studentId, 
            "classId": classId, 
            "sectionId": sectionId || undefined,
            "startDate1": newstartDate, 
            "endDate1": newendDate, 
            "status": true, 
        }
        ActivityService.findActivityList(keys).then((res) => {
            excelExport(res);
            // setClassValue("");
            setActivityList(res);
            // setStudentList(res);
        }).catch((err) => {
            // setError(err.message);
        });

    };
    
    const getSubActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: formik.values.classId,
            activityId: event.target.value
        };
        SubActivityService.getAllSubActivityByActivityId(getsubActList).then((res) => {
            setSubActivityList(res);
            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    
    const getActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: formik.values.classId,
            superActivityId: event.target.value
        };

        ActivityTabelService.getAllActivityTabeBySuperActivityId(getsubActList).then((res) => {
            setAddActivityList(res);
            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getStudentList = (event, obj, sectionIdOverride) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const selectedClassId = event.target.value;
        
        // Clear student list if no class is selected
        if (!selectedClassId || selectedClassId === '') {
            setStudentList([]);
            return;
        }
        
        const getStuList = {
            classId: selectedClassId,
        };
        // If a section is selected (from state or override), filter students by section as well
        const effectiveSectionId = sectionIdOverride !== undefined ? sectionIdOverride : sectionId;
        if (effectiveSectionId) {
            getStuList.sectionId = effectiveSectionId;
        }

        StudentService.getAllStudentById(userDetails.schooleId, getStuList
        ).then((res) => {
            let studentDetails = res.map(res => {
                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            });

            setStudentList(studentDetails);

            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
            setStudentList([]);
        });
    }


    const getStudentActivityList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        ActivityTabelService.getStudentActivity(userDetails.schooleId, false).then((res) => {
            setActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }


    const editActivity = (useractivitys, status) => {
        debugger
        const obj = JSON.parse(JSON.stringify(useractivitys, status));
        obj.classId = useractivitys.classId ? useractivitys.classId._id : '';
        obj.sectionId = useractivitys.sectionId ? useractivitys.sectionId._id : '';

        obj.studentId = Array.isArray(useractivitys.studentId)
            ? useractivitys.studentId.map(student => student._id)
            : [useractivitys.studentId]

        obj.superActivityId = useractivitys.superActivityId ? useractivitys.superActivityId._id : '';
        obj.activityId = useractivitys.activityId ? useractivitys.activityId._id : '';
        obj.subActivityId = useractivitys.subActivityId ? useractivitys.subActivityId._id : '';
        obj.isEdit = true;
        getSuperActivityList({ target: { value: obj.classId } }, obj);
        if (obj.classId) {
            loadDialogSectionList(obj.classId);
        }
        getStudentList({ target: { value: obj.classId } }, obj, obj.sectionId || undefined);
        getSubActivityList({ target: { value: obj.activityId } }, obj);
        getActivityList({ target: { value: obj.superActivityId } }, obj);
        getAddClassList({ target: { value: obj.superActivityId } }, obj)
        //getStudentActivityList(useractivitys.classId);
        if (status) {
            delete obj._id;
        }
        obj.isEdit = true;
        setActivity(obj);
        handleOpen()
    }

    const deleteActivity = (activitydelete) => {
        if (activitydelete) {
            ActivityService.deleteActivity(activitydelete).then((res) => {
                onSubmit();
                setOpenDeleteDialog(false);
                setActivityToDelete(null);
                setMessageDialogContent({
                    title: 'Success',
                    message: 'Activity deleted successfully.',
                    type: 'success'
                });
                setOpenMessageDialog(true);
            }).catch((err) => {
                setOpenDeleteDialog(false);
                setActivityToDelete(null);
                setMessageDialogContent({
                    title: 'Error',
                    message: err.response?.data?.message || 'Failed to delete activity.',
                    type: 'error'
                });
                setOpenMessageDialog(true);
            });
        }
    };

    const handleDeleteClick = (activityId) => {
        setActivityToDelete(activityId);
        setOpenDeleteDialog(true);
    };

    const handleDeleteConfirm = () => {
        if (activityToDelete) {
            deleteActivity(activityToDelete);
        }
    };

    const handleDeleteCancel = () => {
        setOpenDeleteDialog(false);
        setActivityToDelete(null);
    };
    const handlePublicStatusClick = (activity) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getStatus = {
            publicStatus: "publish",
            _id: activity._id

        };
        ActivityService.upadePublicStatus(getStatus).then((res) => {
            setMessageDialogContent({
                title: 'Success',
                message: 'Reports published successfully',
                type: 'success'
            });
            setOpenMessageDialog(true);
            activity.publicStatus = "publish";
            // Refresh the activity list with current filters
            onSubmit(startDate1, endDate1);

        }).catch((err) => {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to update public status.',
                type: 'error'
            });
            setOpenMessageDialog(true);
        });
    }


    return (

        <>
            <PageTitle title="Activity Planner" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Activity
            </Button>} />

            <Card sx={{ maxWidth: 345 }}>
                <Box style={{ margin: 15, }} >


                    <Grid container spacing={2} columns={12} style={{ margin: 10, }}  >
                        <Grid item xs={6} sm={6} md={2}  >
                            <FormControl className={classes.formControl} style={{ width: 170 }}
                            >
                                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="classId"
                                    label="selectClass"
                                    onChange={e => { 
                                        const value = e.target.value;
                                        setClassId(value); 
                                        setSectionId('');
                                        getStudentList(e);
                                        getSectionListByClass(value);
                                    }}
                                    value={classId}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}

                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={6} sm={6} md={2}  >
                            <FormControl className={classes.formControl} style={{ width: 170 }}>
                                <InputLabel id="section-select-label">Select Section</InputLabel>
                                <Select
                                    labelId="section-select-label"
                                    id="section-select"
                                    name="sectionId"
                                    label="Select Section"
                                    value={sectionId}
                                    onChange={(e) => {
                                        setSectionId(e.target.value);
                                    }}
                                    disabled={!classId || sectionList.length === 0}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {sectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}  >
                            <FormControl variant="standard" fullWidth>
                                <InputLabel id="studentName">Student Name</InputLabel>
                                <Select
                                    labelId="studentName"
                                    id="studentName"
                                    label="Student Name"
                                    name="studentId"
                                    value={studentId}
                                    onChange={e => { setStudentId(e.target.value) }}

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {studentList.map(({ index, _id, studentName }) => (
                                        <MenuItem key={index} value={_id}>{studentName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <form className={classes.container} noValidate>
                                <TextField InputProps={{ style: { width: 140 } }}
                                    id="dob"
                                    name="dob"
                                    label="Start Date"
                                    type="date"
                                    min="2016-11-10"
                                    max="2022-11-10"
                                    value={startDate1}
                                    onChange={e => { 
                                        setStartDate1(e.target.value);
                                        // If end date is before new start date, clear it
                                        if (endDate1 && e.target.value && new Date(e.target.value) > new Date(endDate1)) {
                                            setEndDate1('');
                                        }
                                    }}
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </form>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <TextField InputProps={{ style: { width: 140 } }}
                                id="dob"
                                name="dob"
                                label="End Date"
                                type="date"
                                min={startDate1 || "2016-11-10"}
                                max="2022-11-10"
                                value={endDate1}
                                onChange={e => { 
                                    const selectedEndDate = e.target.value;
                                    // Only allow if end date is greater than or equal to start date
                                    if (!startDate1 || new Date(selectedEndDate) >= new Date(startDate1)) {
                                        setEndDate1(selectedEndDate);
                                    } else {
                                        // Show error or prevent selection
                                        setMessageDialogContent({
                                            title: 'Validation Error',
                                            message: 'End date must be greater than or equal to start date',
                                            type: 'error'
                                        });
                                        setOpenMessageDialog(true);
                                    }
                                }}
                                error={endDate1 && startDate1 && new Date(endDate1) < new Date(startDate1)}
                                helperText={endDate1 && startDate1 && new Date(endDate1) < new Date(startDate1) ? 'End date must be >= start date' : ''}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2}>
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                type="button"

                                onClick={() => onSubmit(startDate1, endDate1)} variant="contained"
                            >
                                Search</Button>
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <ExportExcel style={{ fontSize: "11px", }} excelData={result} fileName={'Activity recorder'} />
                        </Grid>
                    </Grid>
                    <Box className={classes.infoNote}>
                        <InfoOutlinedIcon className={classes.infoNoteIcon} fontSize="small" />
                        <Box>
                            <Typography variant="subtitle2" className={classes.infoNoteLabel}>
                                Tip
                            </Typography>
                            <Typography variant="body2" className={classes.infoNoteText}>
                                To view previous week activity, set <strong>Start Date</strong> and <strong>End Date</strong> to that week’s range, then click <strong>Search</strong>.
                            </Typography>
                        </Box>
                    </Box>
                    {/* <Grid container spacing={2} columns={12}   >


                        <Grid item xs={6} sm={6} md={2} >
                            <ExportExcel style={{ fontSize: "11px", }} excelData={result} fileName={'Activity recorder'} />
                        </Grid>
                        <Grid item xs={6} sm={6} md={2} >
                            <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', fontSize: '13px' }} type="button" onClick={() => getStudentReportList()} >student report</Button>
                        </Grid>
                    </Grid> */}


                </Box>
            </Card>
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {activityList
                                    .slice(pg * rpg, pg * rpg + rpg) // Pagination logic
                                    .map((group) => (
                                          group.activityRecordsId.length > 0 && (
                                        <React.Fragment key={group.studentId?._id}>
                                            <TableRow>
                                                <TableCell className="pl-3 fw-bold" colSpan={tableHeaders.length} style={{ backgroundColor: '#7f8582', color: '#ffff', 'font-size': '17px', 'font-weight': '500' }}>
                                                    {group.studentId?.firstName} {group.studentId?.lastName}
                                                </TableCell>
                                            </TableRow>
                                            {group.activityRecordsId.map((activity) => {
                                                const isOverdue = shouldHighlightRow(activity);
                                                return (
                                                <TableRow 
                                                    key={activity._id}
                                                    style={{
                                                        backgroundColor: isOverdue ? '#ffebee' : 'transparent'
                                                    }}
                                                >

                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.classId ? activity.classId.className : ""}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.sectionId ? activity.sectionId.sectionName : ""}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.superActivityId ? activity.superActivityId.superActivityName : ""}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.activityId ? activity.activityId.activityName : ""}
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.subActivityId ? activity.subActivityId.subActivityName : ""}
                                                    </TableCell>

                                                    {/* <TableCell className="pl-3 fw-normal">
                                        {activity.authorizedPerson}
                                    </TableCell> */}
                                                    <TableCell className="pl-3 fw-normal">{activity.remarks}</TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        <span style={getKeyStatusStyle(activity.key)}>
                                                            {getKeyStatusText(activity.key)}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">{formatDate(activity.date)}</TableCell>

                                                    <TableCell className="pl-3 fw-normal">{formatDate(activity.endDate)}</TableCell>                                                    <TableCell>
                                                        <EditIcon 
                                                            style={{ 
                                                                cursor: activity.key === 'M' ? 'not-allowed' : 'pointer',
                                                                opacity: activity.key === 'M' ? 0.5 : 1
                                                            }} 
                                                            onClick={() => {
                                                                if (activity.key !== 'M') {
                                                                    editActivity(activity, false);
                                                                }
                                                            }} 
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <DeleteIcon style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(activity._id)} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <AddIcon 
                                                            style={{ 
                                                                cursor: activity.key === 'M' ? 'not-allowed' : 'pointer',
                                                                opacity: activity.key === 'M' ? 0.5 : 1
                                                            }} 
                                                            onClick={() => {
                                                                if (activity.key !== 'M') {
                                                                    editActivity(activity, true);
                                                                }
                                                            }} 
                                                        />
                                                    </TableCell>
                                                    {/* <TableCell className="pl-3 fw-normal">
                                                        <div style={{ maxHeight: '120px', overflowY: 'auto', padding: '4px' }}>
                                                            {group.activityRecordsId
                                                                .filter(record => record.activityId?._id === activity.activityId?._id)
                                                                .map((record, idx) => (
                                                                    <div key={idx} style={{ marginBottom: '8px' }}>
                                                                        <strong>
                                                                            {record.key === 'P' ? 'Presented'
                                                                                : record.key === 'WI' ? 'Work Independently'
                                                                                    : record.key === 'WA' ? 'Work with Assistance'
                                                                                        : record.key === 'M' ? 'Master'
                                                                                            : record.key}
                                                                        </strong>
                                                                        <br />
                                                                        {Array.isArray(record.statusHistory) && record.statusHistory.length > 0 ? (
                                                                            record.statusHistory
                                                                                .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt))
                                                                                .map((history, hIdx) => (
                                                                                    <div
                                                                                        key={hIdx}
                                                                                        style={{
                                                                                            background: '#f0f4f8',
                                                                                            borderRadius: '6px',
                                                                                            padding: '6px 8px',
                                                                                            marginTop: '4px',
                                                                                            fontSize: '0.85rem',
                                                                                            color: '#333',
                                                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                                                                        }}
                                                                                    >
                                                                                        <strong>
                                                                                            {history.key === 'P' ? 'Presented'
                                                                                                : history.key === 'WI' ? 'Work Independently'
                                                                                                    : history.key === 'WA' ? 'Work with Assistance'
                                                                                                        : history.key === 'M' ? 'Master'
                                                                                                            : history.key}
                                                                                        </strong>
                                                                                        <div style={{ fontSize: '0.75rem', color: '#666' }}>
                                                                                            {new Date(history.changedAt).toLocaleDateString()}
                                                                                        </div>
                                                                                    </div>
                                                                                ))
                                                                        ) : (
                                                                            <span style={{ color: '#999', fontSize: '0.8rem' }}>No History</span>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </TableCell> */}

                                                    <TableCell className="pl-3 fw-normal">
                                                        <Button
                                                            variant="outlined" style={{ backgroundColor: '#5c7a94', color: 'white', border: 'none', padding: '10px' }}
                                                            size="small"
                                                            onClick={() => {
                                                                const record = group.activityRecordsId.find(
                                                                    record => record.activityId?._id === activity.activityId?._id
                                                                );
                                                                setSelectedHistory(record?.statusHistory || []);
                                                                setOpenHistory(true);
                                                            }}
                                                        >
                                                            History
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell className="pl-3 fw-normal">
                                                        {activity.publicStatus === 'draft' ? (
                                                            <button
                                                                style={{
                                                                    padding: '4px 8px',
                                                                    backgroundColor: '#1976d2',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => handlePublicStatusClick(activity)}
                                                            >
                                                                Draft
                                                            </button>
                                                        ) : (
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: 'green',
                                                                    textDecoration: 'underline',
                                                                }}

                                                            >
                                                                Published
                                                            </span>
                                                        )}
                                                    </TableCell>
                                                    {/* <TableCell className="pl-3 fw-normal">
                                                        {activity.publicStatus }
                                                    </TableCell> */}


                                                </TableRow>
                                                );
                                            })}
                                        </React.Fragment>
                                          )
                                    ))}
                            </TableBody>

                        </Table>
                                                </TableContainer >

                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 1000000]}
                            count={activityList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: {
                    width: '460px', // set custom width
                    maxWidth: '80%', // optional, responsive behavior
                }
            }
            }>
                <DialogTitle>Add Activity recorder</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 508 }}>

                        <TextField InputProps={{ style: { width: 200 } }}
                            id="date"
                            name="date"
                            autoFocus
                            label="Start Date"
                            type="date"
                           // ref={formRefs.date}
                            error={formik.touched.date && Boolean(formik.errors.date)}
                            value={formik.values.date}
                            onChange={(e) => {
                                formik.handleChange(e);
                                // If end date is before new start date, clear it
                                if (formik.values.endDate && e.target.value && new Date(e.target.value) > new Date(formik.values.endDate)) {
                                    formik.setFieldValue('endDate', '');
                                }
                            }}
                            helperText={formik.touched.date && formik.errors.date}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField InputProps={{ style: { width: 200 } }}
                            id="endDate"
                            name="endDate"
                            label="End Date"
                            type="date"
                            min={formik.values.date || undefined}
                            value={formik.values.endDate}
                            onChange={(e) => {
                                const selectedEndDate = e.target.value;
                                // Only allow if end date is greater than or equal to start date
                                if (!formik.values.date || new Date(selectedEndDate) >= new Date(formik.values.date)) {
                                    formik.handleChange(e);
                                } else {
                                    // Show error or prevent selection
                                    setMessageDialogContent({
                                        title: 'Validation Error',
                                        message: 'End date must be greater than or equal to start date',
                                        type: 'error'
                                    });
                                    setOpenMessageDialog(true);
                                }
                            }}
                            error={formik.touched.endDate && Boolean(formik.errors.endDate) || (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date))}
                            helperText={
                                formik.touched.endDate && formik.errors.endDate 
                                    ? formik.errors.endDate 
                                    : (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date) 
                                        ? 'End date must be >= start date' 
                                        : '')
                            }
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <FormControl className={classes.formControl} style={{ width: 423 }}
                        >
                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="classId"
                                label="selectClass"
                                value={formik.values.classId}
                                onChange={e => { 
                                    formik.handleChange(e); 
                                    formik.setFieldValue('sectionId', '');
                                    loadDialogSectionList(e.target.value);
                                    getStudentList(e, null, '');
                                    getAllSuperActivityTabelMultiple(e);
                                    // Clear student selection when class changes
                                    if (!e.target.value || e.target.value === '') {
                                        formik.setFieldValue('studentId', []);
                                        setGroupedUnmasteredActivities({});
                                        setFilteredUnmasteredActivities([]);
                                    } else {
                                        // Fetch and group unmastered activities when class is selected
                                        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
                                        fetchAndGroupUnmasteredActivities(e.target.value, userDetails.schooleId);
                                    }
                                }}
                                // onChange={formik.handleChange}
                                //value={classId}
                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                helperText={formik.touched.classId && formik.errors.classId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl className={classes.formControl} style={{ width: 423 }}>
                            <InputLabel id="dialog-section-select-label">Select Section (Optional)</InputLabel>
                            <Select
                                labelId="dialog-section-select-label"
                                id="dialog-section-select"
                                name="sectionId"
                                label="Select Section (Optional)"
                                value={formik.values.sectionId || ''}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    if (formik.values.classId) {
                                        getStudentList({ target: { value: formik.values.classId } }, null, e.target.value || undefined);
                                    }
                                }}
                                disabled={!formik.values.classId || dialogSectionList.length === 0}
                            >
                                {!(userDetails?.role === 'TEACHER' && userDetails?.sectionId) && (
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                )}
                                {dialogSectionList.map(({ _id, sectionName }) => (
                                    <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl variant="standard" style={{ width: 423 }}>
                            <InputLabel id="studentName-label">Student Name</InputLabel>
                            <Select
                                labelId="studentName-label"
                                id="studentName-select"
                                label="Student Name"
                                name="studentId"
                                multiple
                                disabled={formik.values.isEdit || !formik.values.classId || formik.values.classId === ''}
                                value={formik.values.studentId} // make sure this is an array in Formik's initialValues
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    // Only filter if "For All Class Students" is not checked
                                    if (!formik.values.isEventForAllStudent) {
                                        // Filter unmastered activities based on selected students
                                        const selectedStudentIds = e.target.value;
                                        if (selectedStudentIds && selectedStudentIds.length > 0) {
                                            const filtered = [];
                                            selectedStudentIds.forEach(studentId => {
                                                if (groupedUnmasteredActivities[studentId]) {
                                                    filtered.push(...groupedUnmasteredActivities[studentId]);
                                                }
                                            });
                                            setFilteredUnmasteredActivities(filtered);
                                        } else {
                                            setFilteredUnmasteredActivities([]);
                                        }
                                    }
                                    // If "For All Class Students" is checked, activities are already shown from checkbox onChange
                                }}
                                // Customize how the selected values are displayed in the input
                                renderValue={(selected) => {
                                    if (!formik.values.classId || formik.values.classId === '') {
                                        return 'Please select a class first';
                                    }
                                    // Find student names for the selected IDs
                                    const selectedNames = studentList
                                        .filter(({ _id }) => selected.includes(_id))
                                        .map(({ studentName }) => studentName);
                                    return selectedNames.length > 0 ? selectedNames.join(", ") : '';
                                }}
                            >
                                {studentList.length === 0 ? (
                                    <MenuItem disabled value="">
                                        {formik.values.classId ? 'No students found' : 'Please select a class first'}
                                    </MenuItem>
                                ) : (
                                    studentList.map(({ _id, studentName }) => (
                                        <MenuItem key={_id} value={_id}>
                                            {studentName}
                                        </MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                        
                        <div>

                            {formik.values.isEventForAllStudent}
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="isEventForAllStudent" id="terms"
                                            value={formik.values.isEventForAllStudent}
                                            checked={formik.values.isEventForAllStudent}
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                // If "For All Class Students" is checked, show all unmastered activities
                                                if (e.target.checked) {
                                                    // Get all activities from groupedUnmasteredActivities
                                                    const allActivities = [];
                                                    Object.values(groupedUnmasteredActivities).forEach(activities => {
                                                        allActivities.push(...activities);
                                                    });
                                                    setFilteredUnmasteredActivities(allActivities);
                                                } else {
                                                    // If unchecked, filter based on selected students
                                                    const selectedStudentIds = formik.values.studentId || [];
                                                    if (selectedStudentIds.length > 0) {
                                                        const filtered = [];
                                                        selectedStudentIds.forEach(studentId => {
                                                            if (groupedUnmasteredActivities[studentId]) {
                                                                filtered.push(...groupedUnmasteredActivities[studentId]);
                                                            }
                                                        });
                                                        setFilteredUnmasteredActivities(filtered);
                                                    } else {
                                                        setFilteredUnmasteredActivities([]);
                                                    }
                                                }
                                            }}
                                            error={formik.touched.isEventForAllStudent && Boolean(formik.errors.isEventForAllStudent)}
                                            helperText={formik.touched.isEventForAllStudent && formik.errors.isEventForAllStudent}
                                        />
                                    }
                                    label="For All Class Students"
                                />
                            </Grid>

                        </div>
                        
                        {/* Display unmastered activities for selected students or all if "For All Class Students" is checked */}
                        {(() => {
                            // Get activities to display - all if "For All Class Students" is checked, otherwise filtered
                            const activitiesToDisplay = formik.values.isEventForAllStudent 
                                ? Object.values(groupedUnmasteredActivities).flat()
                                : filteredUnmasteredActivities;
                            
                            return activitiesToDisplay.length > 0 && (
                                <FormControl variant="standard" style={{ width: 423, marginTop: '16px' }}>
                                    <InputLabel id="unmastered-activities-label">Unmastered Activities</InputLabel>
                                    <Select
                                        labelId="unmastered-activities-label"
                                        id="unmastered-activities-select"
                                        label="Unmastered Activities"
                                        multiple
                                        value={[]}
                                        renderValue={() => `${activitiesToDisplay.length} unmastered activity(ies) found`}
                                        style={{ maxHeight: '200px', overflowY: 'auto' }}
                                    >
                                        {activitiesToDisplay.map((activity, index) => {
                                        const studentName = activity.studentId?.fullName || 
                                            (activity.studentId?.firstName && activity.studentId?.lastName 
                                                ? `${activity.studentId.firstName} ${activity.studentId.lastName}` 
                                                : 'Unknown Student');
                                        const activityName = activity.activityId?.activityName || 'Unknown Activity';
                                        const subActivityName = activity.subActivityId?.subActivityName || '';
                                        const superActivityName = activity.superActivityId?.superActivityName || '';
                                        const keyText = activity.keyText || activity.key || '';
                                        
                                        return (
                                            <MenuItem key={index} value={activity._id} disabled>
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                    <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                                                        {studentName}
                                                    </div>
                                                    <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                                        <div><strong>Area:</strong> {superActivityName}</div>
                                                        <div><strong>Activity:</strong> {activityName}</div>
                                                        {subActivityName && <div><strong>Exercise:</strong> {subActivityName}</div>}
                                                        <div><strong>Status:</strong> <span style={{ color: '#ff9800', fontWeight: '600' }}>{keyText}</span></div>
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        );
                                        })}
                                    </Select>
                                </FormControl>
                            );
                        })()}
                        
                        {formik.values.isEdit ? (
                            // Show three-level select boxes when editing
                            <>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="demo-simple-select-standard-label">Area Of Work</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="superActivityName"
                                        label="Area Of Work "
                                        name="superActivityId"
                                        onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                        value={formik.values.superActivityId}
                                        error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                        helperText={formik.touched.superActivityId && formik.errors.superActivityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="demo-simple-select-standard-label">List Of Activities</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="activityName"
                                        label="List Of Activities"
                                        name="activityId"
                                        onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                        value={formik.values.activityId}
                                        error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                        helperText={formik.touched.activityId && formik.errors.activityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {addActivityList.map(({ _id, activityName }) => (
                                            <MenuItem key={_id} value={_id}>{activityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl variant="standard" style={{ width: 423 }}>
                                    <InputLabel id="subActivityName">Exercise</InputLabel>
                                    <Select
                                        labelId="subActivityName"
                                        id="subActivityId"
                                        label="Exercise"
                                        name="subActivityId"
                                        value={formik.values.subActivityId}
                                        onChange={formik.handleChange}
                                        error={formik.touched.subActivityId && Boolean(formik.errors.subActivityId)}
                                        helperText={formik.touched.subActivityId && formik.errors.subActivityId}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {subActivityList.map(({ _id, subActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{subActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </>
                        ) : (
                            // Show tree structure when adding new
                            <>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    id="search-activities"
                                    label="Search Activities"
                                    type="text"
                                    variant="outlined"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ marginBottom: '20px' }}
                                    InputProps={{
                                        startAdornment: (
                                            <span style={{ marginRight: '8px' }}>🔍</span>
                                        ),
                                        style: { width: 423 }
                                    }}
                                />
                                <TreeView
                                    defaultCollapseIcon={<ExpandMoreIcon />}
                                    defaultExpandIcon={<ChevronRightIcon />}
                                >
                                    {selectedActivities.map((node) => renderTree(node))}
                                </TreeView>
                            </>
                        )}
                        {/* <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Area Of Work</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="superActivityName"
                                label="Area Of Work "
                                name="superActivityId"
                                onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                value={formik.values.superActivityId}
                                error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                helperText={formik.touched.superActivityId && formik.errors.superActivityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addSuperActivityList.map(({ _id, superActivityName }) => (

                                    <MenuItem key={_id} value={_id}>{superActivityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">List Of Activities</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="activityName"
                                label="List Of Activities"
                                name="activityId"
                                onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                value={formik.values.activityId}
                                error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                helperText={formik.touched.activityId && formik.errors.activityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addActivityList.map(({ _id, activityName }) => (

                                    <MenuItem key={_id} value={_id}>{activityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="subActivityName">Exercise</InputLabel>
                            <Select
                                labelId="subActivityName"
                                id="subActivityId"
                                label="Exercise"
                                name="subActivityId"
                                value={formik.values.subActivityId}
                                onChange={formik.handleChange}
                                error={formik.touched.subActivityId && Boolean(formik.errors.subActivityId)}
                                helperText={formik.touched.subActivityId && formik.errors.subActivityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {subActivityList.map(({ _id, subActivityName }) => (
                                    <MenuItem key={_id} value={_id}>{subActivityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}
                        <FormControl variant="standard" style={{ width: 423 }}>
                            <InputLabel id="demo-simple-select-standard-label">Select Key</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="Key"
                                name="key"
                                value={formik.values.key}
                                onChange={formik.handleChange}
                                error={formik.touched.key && Boolean(formik.errors.key)}
                                helperText={formik.touched.key && formik.errors.key}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {keyOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>

                                ))}
                            </Select>
                        </FormControl>
                        <TextField InputProps={{ style: { width: 423 } }}
                            margin="dense"
                            id="remarks"
                            name="remarks"
                            label="Remarks"
                            type="text"
                            variant="standard"
                            value={formik.values.remarks}
                            onChange={formik.handleChange}
                            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                            helperText={formik.touched.remarks && formik.errors.remarks}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} disabled={addActivityLoading}>Cancel</Button>
                        <Button type="submit" onClick={verifyeetnt} disabled={addActivityLoading}>
                            {addActivityLoading ? (
                                <>
                                    <CircularProgress size={18} style={{ marginRight: 8 }} />
                                    Adding...
                                </>
                            ) : (
                                activity._id ? 'Update' : 'Add'
                            )}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog open={openHistory} onClose={() => setOpenHistory(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Key Status History</DialogTitle>
                <DialogContent dividers style={{ maxHeight: '300px' }}>
                    {selectedHistory.length > 0 ? (
                        selectedHistory
                            .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt))
                            .map((history, index) => (
                                <div
                                    key={index}
                                    style={{
                                        background: '#f1f5f8',
                                        borderRadius: '6px',
                                        padding: '8px',
                                        marginBottom: '8px',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    <span style={getKeyStatusStyle(history.key)}>
                                        {getKeyStatusText(history.key)}
                                    </span>
                                    <div style={{ fontSize: '0.75rem', color: '#555' }}>
                                        {history.changedAt ? new Date(history.changedAt).toLocaleString() : '-'}
                                    </div>
                                </div>
                            ))
                    ) : (
                        <div style={{ color: '#999', fontSize: '0.85rem' }}>No history available.</div>
                    )}
                </DialogContent>
            </Dialog>

            <Dialog 
                open={openMessageDialog} 
                onClose={() => setOpenMessageDialog(false)} 
                maxWidth="sm" 
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                    }
                }}
            >
                <DialogTitle style={{ 
                    backgroundColor: messageDialogContent.type === 'success' ? '#d4edda' : messageDialogContent.type === 'error' ? '#f8d7da' : '#d1ecf1',
                    color: messageDialogContent.type === 'success' ? '#155724' : messageDialogContent.type === 'error' ? '#721c24' : '#0c5460',
                    padding: '20px 24px',
                    borderBottom: `2px solid ${messageDialogContent.type === 'success' ? '#28a745' : messageDialogContent.type === 'error' ? '#dc3545' : '#17a2b8'}`,
                    fontWeight: '600',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    {messageDialogContent.type === 'success' && '✓'}
                    {messageDialogContent.type === 'error' && '✕'}
                    {messageDialogContent.type === 'info' && 'ℹ'}
                    {messageDialogContent.title}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <div style={{ 
                        color: '#333',
                        fontSize: '15px',
                        lineHeight: '1.6'
                    }}>
                        {messageDialogContent.message.split('\n').map((line, index) => {
                            // Check if line starts with bullet point and contains student name
                            if (line.trim().startsWith('•')) {
                                const studentName = line.trim().substring(1).trim(); // Remove bullet and trim
                                return (
                                    <div key={index} style={{ marginBottom: '4px' }}>
                                        • <strong style={{ fontWeight: '700' }}>{studentName}</strong>
                                    </div>
                                );
                            }
                            // Return empty line or regular line
                            if (line.trim() === '') {
                                return <div key={index} style={{ marginBottom: '8px' }}></div>;
                            }
                            return <div key={index} style={{ marginBottom: '4px' }}>{line}</div>;
                        })}
                    </div>
                </DialogContent>
                <DialogActions style={{ 
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6'
                }}>
                    <Button 
                        onClick={() => setOpenMessageDialog(false)}
                        variant="contained"
                        style={{
                            backgroundColor: messageDialogContent.type === 'success' ? '#28a745' : messageDialogContent.type === 'error' ? '#dc3545' : '#17a2b8',
                            color: 'white',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 24px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog 
                open={openDeleteDialog} 
                onClose={handleDeleteCancel} 
                maxWidth="sm" 
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                    }
                }}
            >
                <DialogTitle style={{ 
                    backgroundColor: '#fff3cd',
                    color: '#856404',
                    padding: '20px 24px',
                    borderBottom: '2px solid #ffc107',
                    fontWeight: '600',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    ⚠️ Confirm Delete
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <div style={{ 
                        color: '#333',
                        fontSize: '15px',
                        lineHeight: '1.6'
                    }}>
                        Are you sure you want to delete this activity? This action cannot be undone.
                    </div>
                </DialogContent>
                <DialogActions style={{ 
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6'
                }}>
                    <Button 
                        onClick={handleDeleteCancel}
                        style={{
                            color: '#6c757d',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 20px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleDeleteConfirm}
                        variant="contained"
                        style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 24px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
}


